/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "../http-client";
import {
  CreateTagData,
  DeleteTagByIdData,
  GetTagByIdData,
  GetTagsData,
  TagPatch,
  TagPost,
  UpdateTagByIdData,
} from "../models";

export class Tags<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags tag
   * @name GetTags
   * @summary Get all device tag info
   * @request GET:/tags
   * @secure
   */
  getTags = (
    query: {
      /** Organisation ID */
      organisation_id: string;
      /** Tag value filter */
      value?: string;
      /** Whether retrieving the device list */
      with_relationship?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<GetTagsData, void>({
      path: `/tags`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags tag
   * @name CreateTag
   * @summary Create a new device tag
   * @request POST:/tags
   * @secure
   */
  createTag = (data: TagPost, params: RequestParams = {}) =>
    this.http.request<CreateTagData, void>({
      path: `/tags`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags tag
   * @name DeleteTagById
   * @summary Delete device tag info by uuid
   * @request DELETE:/tags/{tag_uuid}
   * @secure
   */
  deleteTagById = (tagUuid: string, params: RequestParams = {}) =>
    this.http.request<DeleteTagByIdData, void>({
      path: `/tags/${tagUuid}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags tag
   * @name GetTagById
   * @summary Get device tag info by uuid
   * @request GET:/tags/{tag_uuid}
   * @secure
   */
  getTagById = (
    tagUuid: string,
    query?: {
      /** Whether retrieving the device list */
      with_relationship?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<GetTagByIdData, void>({
      path: `/tags/${tagUuid}`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags tag
   * @name UpdateTagById
   * @summary Update device tag info by uuid
   * @request PATCH:/tags/{tag_uuid}
   * @secure
   */
  updateTagById = (tagUuid: string, data: TagPatch, params: RequestParams = {}) =>
    this.http.request<UpdateTagByIdData, void>({
      path: `/tags/${tagUuid}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
